import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx'
import { configs } from './configs';
import {I18nextProvider} from 'react-i18next';
import i18n from './utils/i18n';

i18n.init({
  react: {
    useSuspense: false
  }
});

function runApp() {
  ReactDOM.render(

    <I18nextProvider i18n={ i18n }>
      <App/>
    </I18nextProvider>, document.getElementById('content'));
}

if (!window.Intl) {
  // Fix for safari
  if (!__webpack_public_path__.startsWith('https://local.athlinks.com'))
    __webpack_public_path__ = configs.bragiUrl + '/dist/';

  require.ensure(['intl'], (require) => {
    window.Intl = require('intl');
    require('intl/locale-data/jsonp/en.js');
    runApp();
  }, 'intl-polyfill');
} else {
  runApp();
}



/** WEBPACK FOOTER **
 ** ./client.js
 **/